import React from "react";
import { Fragment } from "react";
import { Container } from "../../components";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { useI18n } from "../../lib/i18n/i18n_provider";
import { getLanguageComponent } from "../../lib/locale/locale";
import { TemplateOfferingListingMeetingRoom } from "../template_offering_listing_meeting_room";
import { Text } from "../text";
import { useWeWorkAnalytics } from "./wework_analytics";
import {
  faqsMeetingRoomEN,
  faqsMeetingRoomHE,
  useWeWorkPartnerConfig,
} from "./wework_partner_config";

const Theme = lazyWithRetry(() => import("./wework_theme"));

export function OfferingWeWorkListingClassroom() {
  useWeWorkAnalytics();
  const { locale } = useI18n();
  const partnerConfig = useWeWorkPartnerConfig();
  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingMeetingRoom
        partnerConfig={partnerConfig}
        data={{
          faqs:
            locale.baseLanguageTag === "he"
              ? faqsMeetingRoomHE
              : faqsMeetingRoomEN,
          title: text[getLanguageComponent(locale.languageTag)].title,
          description: (
            <Container>
              <Text>
                {
                  text[getLanguageComponent(locale.languageTag)]
                    .descriptionLine1
                }
              </Text>
              <Text>
                {
                  text[getLanguageComponent(locale.languageTag)]
                    .descriptionLine2
                }
              </Text>
              <Text>
                {
                  text[getLanguageComponent(locale.languageTag)]
                    .descriptionLine3
                }
              </Text>
            </Container>
          ),
        }}
      />
    </Fragment>
  );
}

const text: {
  [lang: string]: {
    title: string;
    descriptionLine1: string;
    descriptionLine2: string;
    descriptionLine3: string;
  };
} = {
  en: {
    title: "Book a Classroom at WeWork",
    descriptionLine1: "Book a premium Classroom at WeWork location.",
    descriptionLine2:
      "Whether you need a space for classes, off-sites, or just looking for a private space for working productively - we’ve got you covered.",
    descriptionLine3: "Reserve a room in advance, check-in, and get to work.",
  },
  he: {
    title: "שריינו כיתות ב-WeWork",
    descriptionLine1: "שריינו כיתות בסטנדרט הבינלאומי של-WeWork.",
    descriptionLine2:
      "בין אם אתם צריכים חלל עבור הדרכות, העברת קורס, פעילות גיבוש או סתם חלל פרטי לעבודה פרודוקטיבית, אנחנו כאן בדיוק בשביל זה.",
    descriptionLine3:
      "איך זה עובד? מזמינים חדר ישיבות, מגיעים ביום ההזמנה לצ'ק אין זריז עם הצוות שלנו בדלפק הקבלה וניגשים לעניינים.",
  },
};
